import router from './router';
import {
  getAvatarImagesBank,
  getRankingAndLevelInformation,
  getCoinsInformation,
  saveAvatarSelection,
  getAvatarByChild,
  getChildLockedBadges,
  getChildUnlockedBadges,
  getChildCoinsValues,
  updateCoinstValues,
} from './services';

export {
  router,
  getAvatarImagesBank,
  getRankingAndLevelInformation,
  getCoinsInformation,
  saveAvatarSelection,
  getAvatarByChild,
  getChildLockedBadges,
  getChildUnlockedBadges,
  getChildCoinsValues,
  updateCoinstValues,
};
